import React from 'react';
import { Outlet } from 'react-router-dom';

const User: React.FC = (): JSX.Element => {
    return <Outlet />;
};

export default User;
